import React, { useContext, useState, useEffect, useRef } from "react";
import styled from "styled-components";
import emptyPic from "../../../assets/icons/live-class-empty-icon.svg";
import downIcon from "../../../assets/icons/down-icon-bold.svg";
import rightIcon from "../../../assets/icons/rounded-right-icon.svg";
import FreeCourseCard from "../../includes/freeCourse/FreeCourseCard";
import Loader from "../../includes/loader/Loader";
import EmptyPage from "../../includes/emptyPages/EmptyPage";
import { baseConfig } from "../../../axiosConfig";
import { Context } from "../../../contexts/Store";
import Search from "../../includes/search/Search";
import { Popover } from "@mui/material";
import Tabs from "../../includes/tabs/Tabs";
import { useNavigate, useLocation } from "react-router-dom";

export default function FreeCourse() {
    const { state } = useContext(Context);
    const navigate = useNavigate();
    const location = useLocation();
    const sortByButtonRef = useRef(null);
    const categoryButtonsContainer = useRef(null);
    const leftButton = useRef(null);
    const rightButton = useRef(null);
    const searchTimeoutRef = useRef(null);
    const [isLoading, setLoading] = useState(false);

    const getTabFromUrl = () => {
        const params = new URLSearchParams(location.search);
        return params.get("tab") === "my-course" ? "My Course" : "All";
    };

    const [selectedTab, setSelectedTab] = useState(getTabFromUrl());
    const [search, setSearch] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [freeCourseData, setFreeCourseData] = useState([]);
    const [categories, setCategories] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const accessToken = state.user_details.access_token;
    const [reload, setReload] = useState(false);

    const updateUrlWithTab = (tab) => {

        const params = new URLSearchParams(location.search);
        const newUrl = `${location.pathname}?${params.toString()}`;
        if (tab === "My Course") {
            params.set("tab", "my-course");
        } else {
            params.delete("tab");
        }

        navigate(newUrl, { replace: true });
    };

    useEffect(() => {
        updateUrlWithTab(selectedTab);
    }, [selectedTab, navigate, location.pathname]);

    const sortByValues = [
        {
            id: 1,
            name: "Popular",
            value: "Popular",
        },
        {
            id: 2,
            name: "All",
            value: "All",
        },
    ];
    const [selectedSort, setSelectedSort] = useState(sortByValues[1].value);
    const [sortByFilterAnchorEl, setSortByFilterAnchorEl] = useState(null);
    const handleClickSortByFilter = () => {
        setSortByFilterAnchorEl(sortByButtonRef.current);
    };
    const handleCloseSortByFilter = () => {
        setSortByFilterAnchorEl(null);
    };
    const openSortByFilter = Boolean(sortByFilterAnchorEl);
    const sortByFilterPopoverStyle = {
        position: "absolute",
        top: 30,
        left: -34,
    };

    useEffect(() => {
        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }

        searchTimeoutRef.current = setTimeout(() => {
            setDebouncedSearch(search);
        }, 500);

        return () => {
            if (searchTimeoutRef.current) {
                clearTimeout(searchTimeoutRef.current);
            }
        };
    }, [search]);

    useEffect(() => {
        const getFreeCourseData = () => {
            setLoading(true);

            let url =
                selectedTab === "My Course"
                    ? "/students/student-enrolled-courses/"
                    : "/students/fee-courses/";

            const params = new URLSearchParams();
            if (
                selectedTab === "My Course" &&
                url === "/students/fee-courses/"
            ) {
                params.append("favourite", "true");
            }
            if (debouncedSearch) {
                params.append("search", debouncedSearch);
            }
            if (selectedCategories.length > 0) {
                params.append("category", selectedCategories[0]);
            }
            if (selectedSort === "Popular") {
                params.append("sort_by", "most_enrolled");
            }
            params.append("page", currentPage);
            params.append("page_size", 10);

            if (params.toString()) {
                url += `?${params.toString()}`;
            }

            baseConfig
                .get(url, {
                    headers: {
                        Authorization: "Bearer " + accessToken,
                    },
                    params: {
                        items: 9,
                    },
                })
                .then((response) => {
                    const { StatusCode, data } = response.data;

                    if (StatusCode === 6000) {
                        setFreeCourseData(data.data);
                        setTotalPages(data.paginator.num_pages);
                        setLoading(false);
                    } else {
                        setLoading(false);
                    }
                })
                .catch((error) => {
                    if (error?.response?.data?.code === "token_not_valid") {
                        localStorage.clear();
                        window.location = "/";
                    }
                    setLoading(false);
                });
        };
        getFreeCourseData();
    }, [
        reload,
        selectedTab,
        debouncedSearch,
        selectedCategories,
        selectedSort,
        currentPage,
    ]);

    useEffect(() => {
        const getCategories = () => {
            baseConfig
                .get(`/free-courses/categories/`, {
                    headers: {
                        Authorization: "Bearer " + accessToken,
                    },
                })
                .then((response) => {
                    const { StatusCode, data } = response.data;
                    if (StatusCode === 6000) {
                        setCategories(data);
                    } else {
                        setTimeout(() => {
                            alert(
                                "It is taking longer than usual to load categories"
                            );
                        }, 200);
                    }
                })

                .catch((error) => {
                    if (error?.response?.data?.code === "token_not_valid") {
                        localStorage.clear();
                        window.location = "/";
                    }
                });
        };
        getCategories();
    }, [reload]);

    const handleEnroll = async (bookId) => {
        var formdata = new FormData();
        formdata.append("course", bookId);
        try {
            baseConfig
                .post(`/students/enroll-free-course/`, formdata, {
                    headers: {
                        Authorization: "Bearer " + accessToken,
                    },
                })
                .then((response) => {
                    const { StatusCode, data } = response.data;
                    if (StatusCode === 6000) {
                        setReload(!reload);
                    } else {
                        alert("Some error occured");
                    }
                })
                .catch((error) => {
                    if (error?.response?.data?.code === "token_not_valid") {
                        localStorage.clear();
                        window.location = "/";
                    }
                });
        } catch (error) {
            alert("Some error occured");
        }
    };

    const handleLeftScroll = () => {
        categoryButtonsContainer.current.scrollLeft -= 100;
    };

    const handleRightScroll = () => {
        categoryButtonsContainer.current.scrollLeft += 100;
    };

    useEffect(() => {
        const container = categoryButtonsContainer.current;
        if (!container) {
            return;
        }
        const handleScroll = () => {
            const canScrollLeft = container.scrollLeft > 0;
            const canScrollRight =
                container.scrollWidth >
                container.clientWidth + container.scrollLeft;

            if (leftButton.current) {
                if (canScrollLeft) {
                    leftButton.current.removeAttribute("hidden");
                } else {
                    leftButton.current.setAttribute("hidden", true);
                }
            }
            if (rightButton.current) {
                if (
                    canScrollRight &&
                    container.clientWidth !== container.scrollWidth
                ) {
                    rightButton.current.removeAttribute("hidden");
                } else {
                    rightButton.current.setAttribute("hidden", true);
                }
            }
        };
        container.addEventListener("scroll", handleScroll);
        return () => {
            container.removeEventListener("scroll", handleScroll);
        };
    }, [categories, categoryButtonsContainer, leftButton, rightButton]);

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    return (
        <MainContainer>
            <FreeCourseText>Free Course</FreeCourseText>
            <CategoryTextWrapper>
                <MiddleSection>
                    <SelectDiv>
                        <ProgramButtonDiv>
                            <ProgramButton
                                background={
                                    selectedTab === "All" ? "#fff" : "#F5F5F5"
                                }
                                boxShadow={
                                    selectedTab === "All"
                                        ? "box-shadow: 0px 8px 29px rgba(0, 0, 0, 0.05)"
                                        : "none"
                                }
                                onClick={() => {
                                    setCurrentPage(1);
                                    setSelectedTab("All");
                                    // URL will be updated via useEffect
                                    setReload((prev) => !prev);
                                }}
                            >
                                <ButtonName
                                    color={
                                        selectedTab === "All"
                                            ? "#404040"
                                            : "#9D9D9D"
                                    }
                                >
                                    All
                                </ButtonName>
                            </ProgramButton>
                            <Border>|</Border>

                            <ProgramButton
                                background={
                                    selectedTab === "My Course"
                                        ? "#fff"
                                        : "#F5F5F5"
                                }
                                boxShadow={
                                    selectedTab === "My Course"
                                        ? "box-shadow: 0px 8px 29px rgba(0, 0, 0, 0.05)"
                                        : "none"
                                }
                                onClick={() => {
                                    setCurrentPage(1);
                                    setSelectedTab("My Course");
                                    setReload((prev) => !prev);
                                }}
                            >
                                <ButtonName
                                    color={
                                        selectedTab === "My Course"
                                            ? "#404040"
                                            : "#9D9D9D"
                                    }
                                >
                                    My Course
                                </ButtonName>
                            </ProgramButton>
                        </ProgramButtonDiv>
                    </SelectDiv>

                    <SearchDiv>
                        <Search
                            input={search}
                            setInput={setSearch}
                            search={search}
                            setSearch={setSearch}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                        />
                    </SearchDiv>

                    <DropDownContainer>
                        {selectedTab == "All" && (
                            <>
                                <DropDownDiv>
                                    <SubTitle>Sort by</SubTitle>
                                    <SelectBox
                                        filterOpen={openSortByFilter}
                                        ref={sortByButtonRef}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleClickSortByFilter();
                                        }}
                                    >
                                        <SelectedText>
                                            {selectedSort}
                                        </SelectedText>
                                        <DownIcon src={downIcon} alt="icon" />
                                    </SelectBox>
                                </DropDownDiv>
                                <Popover
                                    style={sortByFilterPopoverStyle}
                                    open={openSortByFilter}
                                    anchorEl={sortByFilterAnchorEl}
                                    onClose={handleCloseSortByFilter}
                                    sx={{
                                        "&& .MuiPopover-paper": {
                                            border: "1px solid #e7e7e7",

                                            boxShadow:
                                                "8px 16px 44px rgba(0, 0, 0, 0.05)",
                                            borderRadius: "12px",
                                        },
                                    }}
                                >
                                    <SortByFilterMainBox>
                                        {sortByValues.map((item) => (
                                            <FilterItem
                                                key={item.id}
                                                onClick={() => {
                                                    if (currentPage != "1") {
                                                        setCurrentPage("1");
                                                    }
                                                    setSelectedSort(item.value);
                                                }}
                                            >
                                                <Round>
                                                    <InnerRound
                                                        selected={
                                                            selectedSort ==
                                                            item.value
                                                        }
                                                    ></InnerRound>{" "}
                                                </Round>
                                                <FilterItemName>
                                                    {item.name}
                                                </FilterItemName>
                                            </FilterItem>
                                        ))}
                                    </SortByFilterMainBox>
                                </Popover>
                            </>
                        )}
                    </DropDownContainer>
                </MiddleSection>
            </CategoryTextWrapper>
            <CategorySection>
                {categories.length > 0 && (
                    <CategoriesButtonWrapper>
                        <CategoriesLeftButton
                            id="left-button"
                            ref={leftButton}
                            hidden
                            onClick={handleLeftScroll}
                        >
                            <ArrowIcon
                                src={rightIcon}
                                style={{
                                    transform: "rotate(180deg)",
                                }}
                                alt="icon"
                            />
                        </CategoriesLeftButton>
                        <CategoryButtonsContainer
                            ref={categoryButtonsContainer}
                        >
                            <Tabs
                                data={categories}
                                setSelectedCategories={setSelectedCategories}
                                selectedCategories={selectedCategories}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                            />
                        </CategoryButtonsContainer>
                        <CategoriesRightButton
                            id="right-button"
                            ref={rightButton}
                            hidden
                            onClick={handleRightScroll}
                        >
                            <ArrowIcon src={rightIcon} alt="icon" />
                        </CategoriesRightButton>
                    </CategoriesButtonWrapper>
                )}
            </CategorySection>
            {isLoading ? (
                <LoadingWrapper>
                    <Loader />
                </LoadingWrapper>
            ) : (
                <>
                    {freeCourseData.length > 0 ? (
                        <ContentWrapper>
                            {freeCourseData.map((freeCourse) => (
                                <SingleCategorizedContent key={freeCourse.id}>
                                    <FreeCourseCard
                                        item={freeCourse}
                                        handleEnroll={handleEnroll}
                                    />
                                </SingleCategorizedContent>
                            ))}
                        </ContentWrapper>
                    ) : (
                        <EmptyContainer>
                            <EmptyPage
                                img={emptyPic}
                                message={"Sorry, nothing here"}
                            />
                        </EmptyContainer>
                    )}

                    {totalPages > 1 && (
                        <PaginationContainer>
                            <PaginationButton
                                onClick={handlePreviousPage}
                                disabled={currentPage === 1}
                            >
                                <ArrowIcon
                                    src={rightIcon}
                                    alt="Previous"
                                    style={{
                                        transform: "rotate(180deg)",
                                    }}
                                />
                            </PaginationButton>

                            <PageNumbers>
                                {Array.from(
                                    { length: Math.min(5, totalPages) },
                                    (_, i) => {
                                        // Show pages around the current page
                                        let pageToShow;
                                        if (totalPages <= 5) {
                                            // If we have 5 or fewer pages, show all pages
                                            pageToShow = i + 1;
                                        } else {
                                            // If we have more than 5 pages, show a window around current page
                                            const leftOffset = Math.max(
                                                0,
                                                Math.min(
                                                    totalPages - 5,
                                                    currentPage - 3
                                                )
                                            );
                                            pageToShow = leftOffset + i + 1;
                                        }

                                        return (
                                            <PageNumber
                                                key={pageToShow}
                                                isActive={
                                                    currentPage === pageToShow
                                                }
                                                onClick={() =>
                                                    setCurrentPage(pageToShow)
                                                }
                                            >
                                                {pageToShow}
                                            </PageNumber>
                                        );
                                    }
                                )}
                            </PageNumbers>

                            <PaginationButton
                                onClick={handleNextPage}
                                disabled={currentPage === totalPages}
                            >
                                <ArrowIcon src={rightIcon} alt="Next" />
                            </PaginationButton>
                        </PaginationContainer>
                    )}
                </>
            )}
        </MainContainer>
    );
}

const MainContainer = styled.div`
    background: #ffffff;
    padding: 25px 8px 25px 20px;
    border: 1px solid #e5e5e5;
    box-sizing: border-box;
    border-radius: 10px;
    height: calc(100vh - 110px);
    overflow-y: scroll;
`;
const FreeCourseText = styled.h5`
    font-size: 1.5rem;
    color: #000000;
    font-weight: 500;
    margin-bottom: 40px;
`;

const ContentWrapper = styled.div`
    margin-top: 30px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 25px;
    justify-content: center;
    padding-right: 12px;

    @media (max-width: 1200px) {
        grid-template-columns: repeat(2, 1fr);
        gap: 20px;
    }

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 15px;
    }
`;

const SingleCategorizedContent = styled.div`
    height: 100%;
`;

const CategoryTextWrapper = styled.div`
    display: flex;
    align-items: center;
    margin-top: 10px;
`;
const CategoryIcon = styled.img`
    height: 20px;
    object-fit: contain;
`;
const CategoryText = styled.h6`
    font-size: 0.95rem;
    color: #404040;
    margin-left: 20px;
`;
const FreeCourseItemsWrapper = styled.div`
    margin-top: 20px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-gap: 15px;
    @media (max-width: 1500px) {
        grid-template-columns: 1fr 1fr 1fr;
    }
    /* @media (max-width: 1180px) {
        grid-template-columns: 1fr 1fr;
    } */
    @media (max-width: 980px) {
        grid-template-columns: 1fr 1fr;
    }
    /* @media (max-width: 840px) {
        grid-template-columns: 1fr;
    } */
`;
const EmptyContainer = styled.div`
    height: calc(100vh - 180px);
    overflow-y: scroll;
    /* border: 1px solid #000; */
`;

const MiddleSection = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;
const SelectDiv = styled.div`
    display: flex;
`;
const ProgramButtonDiv = styled.div`
    width: 235px;
    height: 50px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    background: #f5f5f5;
    padding: 6px 8px;
    border-radius: 12px;
    @media all and (max-width: 1180px) {
        width: 190px;
    }
`;
const ProgramButton = styled.div`
    background-color: ${(props) =>
        props.background ? props.background : "#F5F5F5"};
    padding: 8px 8px;
    min-width: 80px;
    border-radius: 8px;
    height: 36px;
    box-sizing: border-box;
    cursor: pointer;
    @media all and (max-width: 1180px) {
        min-width: 50px;
        padding: 8px 2px;
    }
`;
const Border = styled.span`
    font-size: 1rem;
    color: #e7e7e7;
    display: inline-block;
    margin: 0 10px;
`;
const ButtonName = styled.h3`
    color: ${(props) => (props.color ? props.color : "#9D9D9D")};
    font-size: 0.95rem;
    font-weight: 500;
    padding: 0 10px;
    text-align: center;
`;

const SearchDiv = styled.div`
    display: flex;
    align-items: center;
    width: 600px;

    @media all and (max-width: 1280px) {
        width: 600px;
    }
    @media all and (max-width: 1080px) {
        width: 500px;
    }
    @media all and (max-width: 968px) {
        width: 350px;
    }
`;
const DropDownContainer = styled.div`
    width: 170px;
    display: flex;
    justify-content: flex-end;
    @media all and (max-width: 1300px) {
        width: 100px;
    }
`;
const DropDownDiv = styled.div``;

const SubTitle = styled.span`
    display: inline-block;
    font-size: 10px;
    font-weight: 500;
    color: #010101;
`;
const SelectBox = styled.div`
    width: fit-content;
    max-width: 100%;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #fff;
    cursor: pointer;
    height: 32px;
    box-sizing: border-box;
`;
const SelectedText = styled.span`
    display: inline-block;
    text-transform: capitalize;
    font-size: 16px;
    font-weight: 400;
    color: #404040;
`;
const DownIcon = styled.img`
    width: 10px;
    display: block;
    margin-left: 40px;
`;
const SortByFilterMainBox = styled.div`
    background: #ffffff;
    width: 230px;
    padding: 10px;
    max-height: 60vh;
    overflow-y: scroll;
    overflow-x: hidden;
`;
const FilterItem = styled.div`
    display: flex;
    align-items: center;
    border-radius: 4px;
    padding: 6px;
    cursor: pointer;
    &:hover {
        background: #f5f5f5;
    }
`;
const Round = styled.div`
    width: 19px;
    height: 19px;
    box-sizing: border-box;
    padding: 2px;
    margin-right: 8px;
    border-radius: 50%;
    border: 1px solid #9d9d9d;
`;
const InnerRound = styled.div`
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: ${(props) => (props.selected ? "#917AFD" : "#fff")};
`;
const FilterItemName = styled.div`
    text-transform: capitalize;
    font-size: 14.6px;
    font-weight: 400;
    color: #010101;
    margin-top: 4px;
`;

const CategorySection = styled.div``;

const CategoriesButtonWrapper = styled.div`
    margin-top: 30px;
    display: flex;
    align-items: center;
    position: relative;
`;

const CategoriesLeftButton = styled.div`
    position: absolute;
    left: -20px;
    background-color: transparent;
    border: none;
    color: gray;
    font-size: 1.5rem;
    cursor: pointer;
    &:hover {
        color: black;
    }
`;

const CategoryButtonsContainer = styled.div`
    display: flex;
    align-items: center;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scroll-behavior: smooth;
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
        display: none;
    }
`;

const CategoriesRightButton = styled.div`
    position: absolute;
    right: -20px;
    background-color: transparent;
    border: none;
    color: gray;
    font-size: 1.5rem;
    cursor: pointer;
    &:hover {
        color: black;
    }
`;

const ArrowIcon = styled.img`
    width: 30px;
    display: block;
`;

const PaginationContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
    padding-bottom: 20px;
    position: relative;

    &:before {
        content: "";
        position: absolute;
        top: -20px;
        left: 50%;
        transform: translateX(-50%);
        width: 80px;
        height: 3px;
        background: linear-gradient(
            90deg,
            rgba(145, 122, 253, 0.1),
            rgba(145, 122, 253, 0.7),
            rgba(145, 122, 253, 0.1)
        );
        border-radius: 10px;
    }
`;

const PaginationButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background-color: ${(props) => (props.disabled ? "#f8f8f8" : "#ffffff")};
    border: 1px solid ${(props) => (props.disabled ? "#eeeeee" : "#e5e5e5")};
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
    transition: all 0.3s ease;
    box-shadow: ${(props) =>
        props.disabled ? "none" : "0px 2px 5px rgba(0, 0, 0, 0.04)"};

    &:hover {
        background-color: ${(props) =>
        props.disabled ? "#f8f8f8" : "#f9f9ff"};
        box-shadow: ${(props) =>
        props.disabled ? "none" : "0px 6px 15px rgba(145, 122, 253, 0.1)"};
        transform: ${(props) => (props.disabled ? "none" : "translateY(-2px)")};
    }

    &:active {
        transform: ${(props) => (props.disabled ? "none" : "translateY(0)")};
        box-shadow: ${(props) =>
        props.disabled ? "none" : "0px 2px 5px rgba(0, 0, 0, 0.04)"};
    }

    img {
        width: 18px;
        height: 18px;
        opacity: ${(props) => (props.disabled ? 0.4 : 0.9)};
    }
`;

const PageNumbers = styled.div`
    display: flex;
    align-items: center;
    margin: 0 15px;
`;

const PageNumber = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 38px;
    height: 38px;
    margin: 0 6px;
    border-radius: 50%;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    background-color: ${(props) => (props.isActive ? "#917AFD" : "#ffffff")};
    color: ${(props) => (props.isActive ? "#ffffff" : "#404040")};
    border: 1px solid ${(props) => (props.isActive ? "#917AFD" : "#e5e5e5")};
    transition: all 0.3s ease;
    box-shadow: ${(props) =>
        props.isActive ? "0px 4px 15px rgba(145, 122, 253, 0.2)" : "none"};

    &:hover {
        background-color: ${(props) =>
        props.isActive ? "#917AFD" : "#f9f9ff"};
        box-shadow: ${(props) =>
        props.isActive
            ? "0px 6px 18px rgba(145, 122, 253, 0.25)"
            : "0px 4px 12px rgba(0, 0, 0, 0.05)"};
        transform: ${(props) =>
        props.isActive ? "scale(1.05)" : "translateY(-2px)"};
    }

    &:active {
        transform: scale(1);
        box-shadow: ${(props) =>
        props.isActive
            ? "0px 4px 15px rgba(145, 122, 253, 0.2)"
            : "0px 2px 5px rgba(0, 0, 0, 0.04)"};
    }
`;

const LoadingWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 300px;
    width: 100%;
`;
